import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from './locales/en/translation.json';
import arTranslation from './locales/ar/translation.json';
import jaTranslation from './locales/ja/translation.json';
import zhTranslation from './locales/zh/translation.json';
import frTranslation from './locales/fr/translation.json';
import esTranslation from './locales/es/translation.json';

const resources = {
  en: {
    translation: enTranslation,
  },
  ar: {
    translation: arTranslation,
  },
  ja: {
    translation: jaTranslation,
  },
  zh: {
    translation: zhTranslation,
  },
  fr: {
    translation: frTranslation,
  },
  es: {
    translation: esTranslation,
  },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'ar', 'ja', 'zh', 'fr', 'es'],
    // Drop region tags: ar-AE -> ar, ja-JP -> ja, zh-CN -> zh, fr-CA -> fr, es-MX -> es
    load: 'languageOnly',
    // Accept ja-JP / zh-TW even though only the base codes are in the bundle
    nonExplicitSupportedLngs: true,
    detection: {
      // 1. localStorage: respect a previous manual choice
      // 2. navigator: browser/OS language (this is the "auto" path)
      // 3. htmlTag/cookie/path/subdomain: edge fallbacks
      order: ['localStorage', 'navigator', 'htmlTag', 'cookie', 'path', 'subdomain'],
      caches: ['localStorage'],
      // Only cache a language we actually ship — never write 'ja-JP' to storage
      lookupLocalStorage: 'i18nextLng',
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;

